import React, { useState } from 'react';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import cx from 'classnames';

import CheckmarkListItem, {
  CheckmarkListItemProps,
} from '../CheckmarkListItem';
import SmartLink from '../SmartLink';

import { Heading6, Body1, ButtonText } from '../Typography';
import { ReactComponent as ArrowDownIcon } from '../../assets/svg/accordion-down.svg';

import { useMeasureAccordionContentHeight } from '../../app/hooks/useMeasureAccordionContentHeight';

import styles from './index.module.scss';

export interface AccordionListItemProps {
  title: string;
  text?: string;
  listItems?: CheckmarkListItemProps[];
  buttonText?: string;
  buttonLink?: string;
  className?: string;
  isOpenByDefault?: boolean;
}

const AccordionListItem: React.FC<AccordionListItemProps> = ({
  title,
  text,
  listItems,
  buttonText,
  buttonLink,
  className,
  isOpenByDefault = false,
}) => {
  const [isOpen, setIsOpen] = useState(isOpenByDefault);
  const { contentRef, contentHeight } = useMeasureAccordionContentHeight();

  const handleAccordionClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <li className={cx(styles.wrapper, className)}>
      <button onClick={handleAccordionClick} className={styles.header}>
        <Heading6 className={styles.title}>{title}</Heading6>
        <ArrowDownIcon
          className={cx({
            [styles.arrowDown]: true,
            [styles.arrowUp]: isOpen,
          })}
        />
      </button>

      <div
        ref={contentRef}
        className={styles.contentWrapper}
        style={{ maxHeight: isOpen ? contentHeight : 0 }}
      >
        <div className={styles.content}>
          {text && (
            <Body1 element='div' className={styles.text}>
              <Markdown rehypePlugins={[rehypeRaw as any]}>{text}</Markdown>
            </Body1>
          )}
          {listItems && listItems.length > 0 && (
            <ul className={cx(styles.list, { [styles.noText]: !text })}>
              {listItems.map((item, index) => (
                <CheckmarkListItem
                  key={index}
                  isCheckmarkWhite={false}
                  title={item.title}
                  text={item.text}
                  className={styles.listItem}
                />
              ))}
            </ul>
          )}

          {buttonText && buttonLink && (
            <SmartLink to={buttonLink} className={styles.button}>
              <ButtonText>{buttonText}</ButtonText>
            </SmartLink>
          )}
        </div>
      </div>
    </li>
  );
};
export default AccordionListItem;
